const BASE_KEY = 'settings.materials.material-definitions.delete';

export const DELETE_MATERIAL_KEY = {
    confirmTitle: `${BASE_KEY}.confirm-title`,
    confirmButton: `${BASE_KEY}.confirm-button`,
    confirmMessage: `${BASE_KEY}.confirm-message`,
    notification: {
        success: `${BASE_KEY}.notifications.success`,
        error: `${BASE_KEY}.notifications.error`,
        errorInUse: `${BASE_KEY}.notifications.error-in-use`,
    },
} as const;
